/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */

<script>
import Loading from 'vue-loading-overlay'
import Produto from '@/src/services/produto'
import ProdutoVinculo from "@/src/services/produto-vinculo"
import receitaService from '@/src/services/receita'

export default {
  components: {
    Loading,
  },
  directives: {},
  props: {
    produto: {},
  },
  data() {
    return {
      produtos: [],
      produtoSelecionado: null,

      mensagems: null,
      sucesso: null,
      isLoading: false,
    }
  },
  created() { },
  mounted() {
    this.findAllProducts();
  },
  methods: {
    loading(a) {
      a = !this.isLoading
      return a
    },
    findAllProducts() {
      this.isLoading = true;
      // const token = this.$store.state.auth.currentUser.token;
      // Produto.listar(token).then((response) => {
      //   this.produtos = response.data.dados.filter(data => data.id_empresa_sistema !== null);
      //   this.setProdutoSelecionado();
      //   this.isLoading = false;
      // });

      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      receitaService
        .consultarProduto(token)
        .then((resposta) => {
          this.isLoading = false
          this.produtos = resposta.data.produto
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    // setProdutoSelecionado() {
    //   const produtoEncontrado = this.produtos.find(p => p.id_produto.toString() === this.produto.codigo_webreceita);
    //   if (produtoEncontrado) {
    //     this.produtoSelecionado = produtoEncontrado;
    //   }
    // },
    salvarProduto() {
      const token = this.$store.state.auth.currentUser.token;

      if (!this.produto.codigo_erp || !this.produtoSelecionado) {
        this.$bvToast.toast('Por favor, preencha todos os campos.', {
          variant: 'warning',
          solid: true,
          toaster: 'b-toaster-top-center',
        });
        return;
      }

      const payload = {
        codigo_erp: this.produto.codigo_erp,
        codigo_webreceita: this.produtoSelecionado.idProduto,
      };

      this.isLoading = true;

      const action = this.produto.id_produto_vinculo ? ProdutoVinculo.update : ProdutoVinculo.salvar;
      const actionPayload = this.produto.id_produto_vinculo ? { ...payload, id_produto_vinculo: this.produto.id_produto_vinculo } : payload;

      action(token, actionPayload)
        .then(response => {
          this.isLoading = false;
          this.$bvToast.toast(this.produto.id_produto_vinculo ? 'Produto atualizado com sucesso!' : 'Produto salvo com sucesso!', {
            variant: 'success',
            solid: true,
            toaster: 'b-toaster-top-center',
          });
          if (!this.produto.id_produto_vinculo) {
            this.produto = {};
          }
        })
        .catch(error => {
          this.isLoading = false;
          this.$bvToast.toast('Erro ao salvar produto: verifique os detalhes no console.', {
            variant: 'danger',
            solid: true,
            toaster: 'b-toaster-top-center',
          });
          console.error("Erro ao salvar produto: ", error);
        });
    }
  },
}
</script>

<template>
  <div>
    <b-form>
      <div class="row">
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Cód. ERP" label-for="input-1">
            <b-form-input id="input-1" v-model="produto.codigo_erp" type="text" placeholder="Digite o Código ERP"
              required></b-form-input>
          </b-form-group>
        </div>

        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Produto WebReceita" label-for="produto">
              <v-select
                class="style-select"
                label="nomeProduto"
                :options="produtos"
                :reduce="(item) => item"
                :dense="true"
                v-model="produtoSelecionado"
              >
              </v-select>
          </b-form-group>
        </div>
      </div>
      <b-button type="submit" variant="primary" @click.prevent="salvarProduto">Salvar</b-button>
    </b-form>
    <loading :active.sync="isLoading" color="#008e75" :can-cancel="true"></loading>
  </div>
</template>

<style scoped>
input[disabled],
input[disabled]:hover {
  background: #dddddd;
}
</style>